import conversationHistory from './conversationHistory';
import collapsed from './collapsed';
import realTime from './realTime';
import message from './message';
import error from './error';
import chatVisible from './chatVisible';
import chatSettings from './chatSettings';
import unreadCount from './unreadCount';
import {combineReducers} from 'redux';

export default combineReducers({
  conversationHistory,
  collapsed,
  realTime,
  message,
  error,
  chatVisible,
  chatSettings,
  unreadCount
});



// WEBPACK FOOTER //
// ./chat-app/reducers/index.js